export default __webpack_public_path__ + "static/media/sealsKlein.6a7606c8.jpg";